import { baseApi } from "./baseApi";
import * as API from "@utils/apiPath";
import type { BannerApiResponse, BannerRow } from "interface/banner";
import { StatusInterface } from "interface/common";

export const bannerApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getBanners: builder.query<
      BannerApiResponse,
      { [key: string]: string | number }
    >({
      query: (params) => ({
        url: API.GET_BANNER,
        method: "GET",
        params,
      }),
      providesTags: ["Banner"],
    }),
    createBanner: builder.mutation<
      BannerApiResponse,
      { params: FormData | BannerRow; onClose: () => void }
    >({
      query: ({ params }) => ({
        url: API.GET_BANNER,
        method: "POST",
        body: params,
      }),
      invalidatesTags: ["Banner"],
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
          arg.onClose();
        } catch (error) {
          console.error("Failed to create banner:", error);
        }
      },
    }),
    updateBanner: builder.mutation<
      BannerApiResponse,
      { params: FormData | BannerRow; onClose: () => void }
    >({
      query: ({ params }) => ({
        url: API.GET_BANNER,
        method: "PUT",
        body: params,
      }),
      invalidatesTags: ["Banner"],
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
          arg.onClose();
        } catch (error) {
          console.error("Failed to update banner:", error);
        }
      },
    }),
    updateBannerStatus: builder.mutation<BannerApiResponse, StatusInterface>({
      query: ({ id, ...body }) => ({
        url: `/${API.GET_BANNER}/status/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Banner"],
    }),
    deleteBanner: builder.mutation<BannerApiResponse, string>({
      query: (id) => ({
        url: `/${API.GET_BANNER}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Banner"],
    }),
    bulkUpdateBannerStatus: builder.mutation<
      BannerApiResponse,
      { ids: string[]; status: boolean }
    >({
      query: ({ ids, status }) => ({
        url: `/${API.GET_BANNER}/bulk-status`,
        method: "PUT",
        body: { ids, status },
      }),
      invalidatesTags: ["Banner"],
    }),
    bulkDeleteBanners: builder.mutation<BannerApiResponse, { ids: string[] }>({
      query: ({ ids }) => ({
        url: `/${API.GET_BANNER}/bulk-delete`,
        method: "DELETE",
        body: { ids },
      }),
      invalidatesTags: ["Banner"],
    }),
  }),
});

export const {
  useGetBannersQuery,
  useCreateBannerMutation,
  useUpdateBannerMutation,
  useUpdateBannerStatusMutation,
  useDeleteBannerMutation,
  useBulkUpdateBannerStatusMutation,
  useBulkDeleteBannersMutation,
} = bannerApi;
